import styled, { css } from 'styled-components';

interface DropdownHeaderActionProps {
  open?: boolean;
  hasValue?: boolean;
  textColor?: string;
  arrowColor?: string;
  customFontSize?: number;
}

interface DropdownHeaderProps {
  isLoading: boolean;
  backgroundColor?: string;
  customRadius?: number | string;
  customHeight?: number | string;
  customWidth?: number | string;
  heightScale?: string;
  customFontSize?: number;
}

interface DropdownWrapperProps {
  customWidth?: number | string;
  customHeight?: number | string;
  heightScale?: string;
}

interface DropDownItemListProps {
  size: string;
  customFontSize?: number;
  fullHeight?: number | false;
  leftPosition?: string;
}

export const DropdownWrapper = styled.div<DropdownWrapperProps>`
  position: relative;
  display: flex;
  justify-content: center;
  min-height: 30px;
  flex-wrap: wrap;

  font-family: 'Raleway';

  width: ${props => props.customWidth && `${props.customWidth}%`};
  height: ${props => props.customHeight && `${props.customHeight}${props.heightScale}`};

  &.dropdown-closed {
    ul {
      visibility: hidden;
      pointer-events: none;
      z-index: -999;
      width: 1px;
      height: 1px;
    }
  }
`;

export const DropdownHeader = styled.div<DropdownHeaderProps>`
  background-color: ${props => (props.backgroundColor ? props.backgroundColor : 'transparent')};
  border-radius: 4px;
  border-radius: ${props => (props.customRadius ? `${props.customRadius}px` : '4px')};

  display: flex;
  justify-content: space-between;
  align-items: center;
  width: auto;
  width: ${props => props.customWidth && `${props.customWidth}%`};
  height: ${props => props.customHeight && `${props.customHeight}${props.heightScale}`};
  padding: 0 8px;

  border: solid 0.6px inherit;

  transition: border-color 0.4s, box-shadow 0.4s;

  ${props =>
    props.customHeight &&
    css`
      padding: 16px;
    `};

  ${props =>
    props.isLoading &&
    css`
      pointer-events: none;
      opacity: 0.4;
    `}

  ${props =>
    !props.isLoading &&
    css`
      &:hover {
        cursor: pointer;
        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.2);
      }
    `}
`;

export const DropdownHeaderTitle = styled.div<DropdownHeaderActionProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    margin-right: 12px;

    ${props =>
      props.customFontSize
        ? css`
            font-size: ${props.customFontSize}px;
          `
        : css`
            font-size: 14px;
          `}
    font-weight: bold;

    ${props =>
      props.textColor &&
      css`
        color: ${props.textColor ? props.textColor : '#fff'};
        opacity: 1;
      `};

    ${props =>
      !props.textColor &&
      css`
        color: #fff;
        opacity: 0.5;
      `};
  }
`;

export const DropdownHeaderAction = styled.div<DropdownHeaderActionProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  .chevron {
    transition: 0.4s;
    color: ${props => (props.arrowColor ? props.arrowColor : '#fff')};
  }

  ${props =>
    props.open &&
    css`
      .chevron {
        transform: rotate(-180deg);
      }
    `}
`;

export const ItemsList = styled.ul<DropDownItemListProps>`
  position: absolute;
  z-index: 999;
  overflow-y: auto;

  ${props =>
    props.size === 'small' &&
    css`
      max-height: 340px;
    `}

  ${props =>
    props.size === 'smaller' &&
    css`
      max-height: 170px;
    `}

  ${props =>
    props.fullHeight &&
    css`
      max-height: ${props.fullHeight - 100}px;
    `}

  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075) !important;
  padding: 0;
  margin: 0;
  left: 0;
  width: 100%;
  min-width: 180px;
  margin-top: 45px;

  ${props =>
    props.leftPosition &&
    css`
      left: ${props.leftPosition};
    `}

  scrollbar-width: thin !important;

  &::-webkit-scrollbar {
    height: 8px !important;
    display: unset;
    width: 4px !important;
    /* max-width: 10px !important; */
  }
  &::-webkit-scrollbar-track {
    background: #303236 !important;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #fed44a;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #161a21 !important;
    width: 1px !important;
  }

  li {
    list-style-type: none;
    z-index: 1000;
    ${props =>
      props.customFontSize
        ? css`
            font-size: ${props.customFontSize};
          `
        : css`
            font-size: 14px;
          `}

    &:first-of-type {
      > button {
        border-top: 1px solid #ccc;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
    }

    &:last-of-type > button {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    button {
      display: flex;
      justify-content: space-between;
      background-color: white;
      ${props =>
        props.customFontSize
          ? css`
              font-size: ${props.customFontSize}px;
            `
          : css`
              font-size: 14px;
            `}
      padding: 15px 20px 15px 20px;
      border: 0;
      border-bottom: 1px solid #ccc;
      width: 100%;
      text-align: left;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;

      transition: background-color 0.4s;

      &:hover,
      &:focus {
        cursor: pointer;
        font-weight: bold;
        background-color: #ccc;
      }
    }
  }
`;

export const SelectedItems = styled.p`
  background: rgba(0, 0, 0, 0.2);
  height: 20px;

  padding: 0 8px;

  border-radius: 4px;
`;

export const CustomTitleWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;

export const CustomTitleFirstText = styled.span`
  text-decoration: line-through;
  opacity: 0.7;
`;

export const CustomTitleSecondText = styled.span`
  opacity: 1;
`;
